/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var configuration_service_1 = require("../../common/configuration.service");
var highlight_component_generated_1 = require("../series-item/highlight.component.generated");
/**
 * The Chart series highlighting configuration options.
 */
var SeriesHighlightComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SeriesHighlightComponent, _super);
    function SeriesHighlightComponent(configurationService) {
        var _this = _super.call(this, configurationService) || this;
        _this.configurationService = configurationService;
        return _this;
    }
    SeriesHighlightComponent = tslib_1.__decorate([
        core_1.Component({
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
            selector: 'kendo-chart-series-item-highlight',
            template: ''
        }),
        tslib_1.__metadata("design:paramtypes", [configuration_service_1.ConfigurationService])
    ], SeriesHighlightComponent);
    return SeriesHighlightComponent;
}(highlight_component_generated_1.SeriesHighlightComponentGenerated));
exports.SeriesHighlightComponent = SeriesHighlightComponent;
